export default "__VITE_PUBLIC_ASSET__7522410a__"